export default __webpack_public_path__ + "static/media/fbmessenger.bf07f0ac.svg";